export enum FieldLevel {
  CLIENT = 'C',
  OFFICE = 'O',
  SYSTEM = 'S'
}
